import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import qs from "qs";
import {
  GetCategory,
  GetIdeas,
  GetMostLikedIdeas,
  GetTypeImprovement,
} from "../../../services/ideas";
import { useLocation, useNavigate } from "react-router";
import useBackListener from "../../../libs/hooks/use-back-history";

const MICDashboardContext = createContext();

export const TABS = {
  ALL: "All",
  MOST_LIKED: "Most Liked",
};

export const MICProvider = (props) => {
  const controller = useRef(new AbortController());
  const hasInit = useRef();
  const navigate = useNavigate();
  const params = useLocation();
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState({});
  const [isLoading, setLoading] = useState(true);
  const [category, setCategory] = useState([]);
  const [typeImprovement, setTypeImprovement] = useState([]);
  const [isFetchingMasterData, setIsFetchingMasterData] = useState(true);
  const [countPerPage, setCountPerPage] = useState([]);

  const { tab: tabActive = TABS.ALL } = qs.parse(params.search?.replace("?", ""));

  const queries = useMemo(() => {
    const queryParams = params?.search?.replace("?", "");

    return qs.parse(queryParams);
  }, [params]);

  const onBuildQuery = useCallback((payload) => {
    const newPayload = {
      ...queries,
      typeImprovement:
        payload?.typeImprovement?.join(",") ?? (queries.typeImprovement || ""),
      category,
      tab: payload?.tab ?? (queries?.tab || "")
    };

    if (tabActive) {
      newPayload["tab"] = tabActive;
    }

    const queryBuild = qs.stringify(newPayload);

    navigate(`/mic?${queryBuild}`);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category, queries, tabActive]);

  const onFilterQuery = (payload = {}) => setFilter(payload);

  const getIdeas = useCallback(
    async (params = {}, pageNumber = null, cb) => {
      setLoading(true);
      console.log('GET IDEAS');
      const [err, response] = await GetIdeas(params, { signal: controller.current.signal });
  
      if (err) {
        // toast error
      }
  
      console.log('INIT');
      console.log(tabActive);
      
      setData(response?.data);

  
      if (typeof cb === "function") cb();
      setLoading(false);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [tabActive]
  );

  const getMostLikedIdeas = async (params = {}, cb) => {
    setLoading(true);
    const [err, response] = await GetMostLikedIdeas(params);

    if (err) {
      // toast error
    }

    setData(response?.data);

    if (typeof cb === "function") cb();
    setLoading(false);
  };

  const onSearch = async (creatorName = "") => {
    setLoading(true);
    const payload = {
      ...filter,
      created_by: creatorName,
    };

    setSearch(creatorName);
    onFilter(payload);
  };

  const onChangePage = (newPage) => {
  };

  const onBackPage = () => {
    
  };

  const onFilter = async (payload = {}) => {
    const [err, response] = await GetIdeas(payload);

    if (err) {
      // toast error
    }
    setData(response?.data);

    setLoading(false);
  };

  const onClearData = async (search = null, filter = null) => {
    setLoading(true);
    const payload = {
      created_by: search,
      ...filter,
    };

    if (search === "") {
      delete payload.created_by;

      setSearch("");
    }
    if (filter === "") {
      delete payload.group;
      delete payload.status;

      setFilter({});
    }

    const [err, response] = await GetIdeas(payload);

    if (!err && response) {
      setData(response?.data ?? []);
    }

    setLoading(false);
  };

  useEffect(() => {

    const getMasterDataFilter = async () => {
      const [err, response] = await GetCategory();
      const [errImprovement, responseImprovement] = await GetTypeImprovement();

      if (!err) {
        setCategory(response?.data);
      }

      if (!errImprovement) setTypeImprovement(responseImprovement?.data);

      setIsFetchingMasterData(false);
    };

    getMasterDataFilter();

    if (!hasInit.current && params.pathname === '/mic') {
      if (tabActive === TABS.MOST_LIKED) {
        getMostLikedIdeas({}, () => {
          hasInit.current = true;
        });
      } else {
        getIdeas({}, null, () => {
          hasInit.current = true;
        });
      }
    }

    // return () => {
    //   controller.current.abort();
    // }
  }, [getIdeas, hasInit, params.pathname, tabActive]);

  // Cancelled all on going request while user move to other page
  useBackListener(() => controller.current.abort(), params.pathname);

  const onTabChange = (tab) => {
    navigate(`/mic?tab=${tab}`);
    if (tab === TABS.ALL) getIdeas();
    else getMostLikedIdeas();
  };
  
  
  const contextValues = useMemo(
    () => {
      return {
        tab: tabActive,
        data: data,
        search,
        filter,
        isShowFilterSearch: queries?.tab !== TABS.MOST_LIKED,
        masterData: {
          category,
          isFetching: isFetchingMasterData,
          typeImprovement,
        },
        isLoading,
        actions: {
          onTabChange,
          getIdeas,
          onSearch,
          onChangePage,
          onBackPage,
          onFilter,
          onFilterQuery,
          onClearData,
          onSetLoading: setLoading,
        },
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      data,
      tabActive,
      isLoading,
      isFetchingMasterData,
      category,
      typeImprovement,
    ]
  );

  return (
    <MICDashboardContext.Provider value={contextValues}>
      {props?.children}
    </MICDashboardContext.Provider>
  );
};

export const useMICContext = () => useContext(MICDashboardContext);

export const useMICList = () => {
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const getIdeas = async () => {
    setLoading(true);

    const [err, response] = await GetIdeas();

    if (err) {
      // toast error
    }
    setData(response?.data);
    setLoading(false);
  };

  useEffect(() => {
    getIdeas();
  }, []);

  return { data, isLoading, onRefresh: getIdeas };
};

export const useMICDetails = () => {};
